import React from "react";
//var RangeDatePicker = require('react-google-flight-datepicker');
import { RangeDatePicker } from "react-google-flight-datepicker";
// import "./DateRange.scss"; // Removed for version update

const DateRange = ({ changeDate, startDate, endDate, disabledAfterDate }) => {
  return (
    <RangeDatePicker
      highlightToday
      // startDate={startDate}
      // endDate={endDate}
      className="date-picker"
      startDatePlaceholder="Start Date"
      endDatePlaceholder="End Date"
      maxDate={disabledAfterDate}
      onChange={(startDate, endDate) => changeDate(startDate, endDate)}
    />
  );
};

export default DateRange;
